module.exports = __webpack_public_path__ + "static/img/Frame 1822.c869946.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/Frame 1822.png
// module id = 7DiP
// module chunks = 12